// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import 'snippets/cart-js/cart-js';
import 'snippets/mini-cart/mini-cart';
import 'snippets/tooltip/tooltip';

import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_cart.scss';
